"use strict";
module.exports = {
    AMPLITUDE_API_KEYS: {
        QA: "5c88fe8d83b3fe0e258ce1ebb0e2963d",
        STAGING: "e3cca0c4e7b31d9282bc6afa3538b70e",
        PRODUCTION: "29fd9abf9fb0e60e22136ab6f59a84b1"
    }
};



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/utils/urp/amplitude.js